/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './InsightsCards.scss';

import { array, string } from 'prop-types';
import React from 'react';
import TRP from 'components/shared/TRP/TRP';

import ProductCard from 'components/shared/ProductCard/ProductCard';

import { FormattedDate } from 'components/shared/Text/Text';

const InsightCard = ({
  startDate,
  messageText,
  messageUrl,
  linkText,
  messageSummary,
  isMarketingTest,
  messageId
}) => (
  <ProductCard
    className="insight-card"
    title={
      <FormattedDate className="insight-time-stamp">{startDate}</FormattedDate>
    }
    description={messageSummary}
    content={messageText}
    messageId={messageId}
    isMarketingTest={isMarketingTest}
    buttons={messageUrl && <a href={messageUrl}>{linkText}</a>}
  />
);

InsightCard.propTypes = {
  messageTimestamp: string,
  messageText: string,
  messageName: string,
  messageSummary: string
};

const InsightCards = ({ insights = [] }) => (
  <div className="insights-module">
    <div className="insights-module-title">
      Insights From <TRP />
    </div>
    <div className="insights-module-cards-container">
      {insights.map((insight, i) => (
        <InsightCard key={i} {...insight} />
      ))}
    </div>
  </div>
);

InsightCards.propTypes = {
  insights: array
};

export default InsightCards;
